import React from "react";

import {
  MdCalendarToday,
  MdLocationPin,
  MdOutlineEmail,
  MdOutlinePhoneIphone,
} from "react-icons/md";

import Card from "../Components/UI/Card";

const About = () => {
  return (
    <div className="flex flex-col gap-2 p-4 pt-2 md:grid lg:grid-cols-2 md:gap-4 ">
      <Card>
        <div className="flex justify-between gap-2 p-2 text-start md:p-4 bg-slate-900 item-center">
          <div>
            <p>Phone Number</p>
            <a href="tel:+918828674110">+91 - 88 2867 4110</a>
          </div>

          <MdOutlinePhoneIphone className="w-8 h-8 mx-0 my-auto text-[#c8c8c8]" />
        </div>
      </Card>

      <Card>
        <div className="flex justify-between gap-2 p-2 text-start md:p-4 bg-slate-900 item-center ">
          <div>
            <p>Date of Birth</p>
            <p>Jun 10, 1998</p>
          </div>

          <MdCalendarToday className="w-8 h-8 mx-0 my-auto text-[#c8c8c8]" />
        </div>
      </Card>

      <Card>
        <div className="flex justify-between gap-2 p-2 text-start md:p-4 bg-slate-900 item-center ">
          <div>
            <p>E-mail</p>
            <a href="mailto:mansoor4tech@gmail.com">mansoor4tech@gmail.com</a>
          </div>

          <MdOutlineEmail className="w-8 h-8 mx-0 my-auto text-[#c8c8c8]" />
        </div>
      </Card>

      <Card>
        <div className="flex justify-between gap-2 p-2 text-start md:p-4 bg-slate-900 item-center ">
          <div>
            <p>Current City</p>
            <p>Kalyan, MH, IND</p>
          </div>

          <MdLocationPin className="w-8 h-8 mx-0 my-auto text-[#c8c8c8]" />
        </div>
      </Card>
    </div>
  );
};

export default About;
